import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Picture from "./components/Picture";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import AboutDetail from "./components/AboutDetail";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        {/* Halaman utama */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Picture />
              <About />
              <Services />
              <Projects />
              <Contact />
            </>
          }
        />

        {/* Halaman lain */}
        <Route path="/about-detail" element={<AboutDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
